<template>
    <fade-animation
            :from="{y: 50, opacity: 0}"
            :to="{y:0, opacity: 1}"
            key="heading-animation"
            v-if="title"
            class="heading-block first-block full-width"
    >
        <div class="full-width" :style="{backgroundColor: background_color}">
            <div class="page-container">
                    <div :class="['wrap-heading', {'white-text': white_text}]">
                        <div class="left">
                            <h1 class="h1">{{title}}</h1>
                        </div>
                        <div class="right">
                            <div class="text" v-html="text"></div>
                        </div>
                    </div>
            </div>
        </div>
    </fade-animation>
</template>

<script>
    import FadeAnimation from '../../modules/includes/FadeAnimation'

    export default {
        name: "HeadingBlock",
        components: {
            FadeAnimation
        },
        props: {
            title: {
                type: String,
                default: "",
            },
            text: {
                type: String,
                default: "",
            },
            background_color: {
                type: [String, Boolean],
                default: "#fff",
            },
            white_text: {
                type: Boolean,
                default: false,
            }
        },
    }
</script>

<style lang="scss" scoped>
    .heading-block{
        position: relative;
        z-index: 5;

        &.first-block{
            padding-top: 300px;

            @media (max-width: 1100px){
                padding-top: 200px;
            }

            @media (max-width: 767px){
                padding-top: 230px;
            }
        }

        .full-width{
            background-color: #fff;
            width: 100%;
            max-width: calc(100% - 40px);
            margin: auto;
            @include box-shadow;

            @media (max-width: 600px) {
                max-width: calc(100% - 30px);
            }
        }

        .wrap-heading{
            display: flex;
            justify-content: space-between;
            padding: 80px 105px 60px;

            @media (max-width: 1100px){
                flex-direction: column;
                padding: 30px 40px;
            }

            .left{
                width: 45%;

                @media (max-width: 1100px){
                    width: 100%;
                }
            }

            .right{
                width: 50%;

                @media (max-width: 1100px){
                    width: 100%;
                }

                .text{
                    padding-right: 80px;

                    @media (max-width: 1100px){
                        padding-right: 0;
                    }
                }
            }

            &.white-text{
                * {
                    color: #fff;
                }
            }
        }
    }
</style>